// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--b51c5";
export var screen1__container = "screen1-module--screen1__container--15df6";
export var screen1__link = "screen1-module--screen1__link--38795";
export var screen1__linkWrapper = "screen1-module--screen1__link-wrapper--4cf52";
export var screen1__subtitle = "screen1-module--screen1__subtitle--4192e";
export var screen1__title = "screen1-module--screen1__title--6b57e";
export var screen1__titleWrapper = "screen1-module--screen1__title-wrapper--acbe7";
export var screen1__wrapper = "screen1-module--screen1__wrapper--c7b91";